import { initVueApp } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/init_vue_app.js?vue3';
import { parseBoolean } from '~/lib/utils/common_utils';
import { getParameterByName } from '~/lib/utils/url_utility';
import AmbiguousRefModal from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/ref/components/ambiguous_ref_modal.vue?vue3';
import { REF_TYPE_PARAM_NAME, TAG_REF_TYPE, BRANCH_REF_TYPE } from './constants';

export default (el = document.querySelector('#js-ambiguous-ref-modal')) => {
  const refType = getParameterByName(REF_TYPE_PARAM_NAME);
  const isRefTypeSet = refType === TAG_REF_TYPE || refType === BRANCH_REF_TYPE; // if ref_type is already set in the URL, we don't want to display the modal
  if (!el || isRefTypeSet || !parseBoolean(el.dataset.ambiguous)) return false;

  const { ref } = el.dataset;

  return initVueApp({
    el,
    name: 'AmbiguousRefModalRoot',
    component: AmbiguousRefModal,
    props: { refName: ref },
  });
};
